/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <ChatWidget :config="config"></ChatWidget>
  </div>
</template>

<script>
import { deptList, chatBOTGet, deptDelete } from '../../api/userMG'
import ChatWidget from '../../components/ChatWidget'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      payType: [
        { key: '全部', value: 0 },
        { key: 'chatWEB', value: 'chatWEB' },
        { key: 'chatBOT', value: 'chatBOT' },
        { key: 'chatAPl', value: 'chatAPl' },
      ],
      title: '新增',
      editForm: {
        Id: '',
        Name: '',
        platform: '',
        type: '',
        k_id:'',
        is_network:'0',
        is_upload:'0',
        token: localStorage.getItem('logintoken')
      },
      config:{
      title: "智能客服",
      theme: "#F68020",
      welcome: "您好，我是智能助手，有什么可以帮您解答的问题？",
      avatar: "",
      logo:'',
      position: "right",
      recommendQuestions: ["实名认证多久通过？", "SDK使用手册"],
      isNetwork: false,
      isUpload: false,
      is_show:true,
      is_online:2,
      is_show_online:false,
      contact_content: "",
      api_key:'EUjR5xntfO4TA_qQp8yQ0aHnjhkBObL9y_akWVJw_N8',
    },
      // rules表单验证
      rules: {
        Name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        platform: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    ChatWidget
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  //  beforeCreate(){
  //   this.getchat();
  // },
  created() {
    //this.getdata(this.formInline)
    // 在渲染页面之前加载数据，推荐使用beforeCreate或created生命周期钩子
    // 这里在created中调用getchat方法，确保数据在页面渲染前获取
   this.getchat();
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getchat(){
      chatBOTGet(1)
        .then(res => {
          this.loading = false
          console.log(res,'-YVjWGa_eq7gz802Xf2WiwVdZOxgW7qG6-02NzRB7VU')
          if (res.message == "success") {
              // 将十六进制颜色转换为RGB格式，便于--chat-bubble-color渲染
              this.config.theme = this.hexToRgb(res.data.theme_color);
              this.config.avatar =  res.data.icon;
              this.config.logo =  res.data.logo;
              this. config.title =  res.data.name;
              this.config.welcome =  res.data.welcome_speech;
              this.config.recommendQuestions =  res.data.recommended_question;
              if(res.data.customer_guidance=="on"){
                this.config.contact_content =  res.data.customer_guidance_text;
              }
              if(res.data.status=="normal"){
                this.config.is_show =  true;
              }
              //  this.config.api_key =  res.data.api_key;
              console.log(this.config,1111);
          } else {
            this.$message({
              type: 'info',
              message: res.detail
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    hexToRgb(hex) {
        // 移除可能存在的 # 符号
        hex = hex.replace(/^#/, '');
        // 处理缩写形式（如 #FFF => FFFFFF）
        if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }

        // 将十六进制分解为RGB分量
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `${r}, ${g}, ${b}`;
      },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
        data: [
          {
            addUser: null,
            editUser: null,
            addTime: 1521062371000,
            editTime: 1526700200000,
            deptId: 2,
            deptName: 'XX分公司',
            deptNo: '1',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1521063247000,
            editTime: 1526652291000,
            deptId: 3,
            deptName: '上海测试',
            deptNo: '02',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526349555000,
            editTime: 1526349565000,
            deptId: 12,
            deptName: '1',
            deptNo: '11',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526373178000,
            editTime: 1526373178000,
            deptId: 13,
            deptName: '5',
            deptNo: '5',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526453107000,
            editTime: 1526453107000,
            deptId: 17,
            deptName: 'v',
            deptNo: 'v',
            parentId: 1
          }
        ]
      }
      this.loading = false
      this.listData = res.data
      this.pageparm.currentPage = res.data.page_info.page
      this.pageparm.pageSize = res.data.page_info.page_size
      this.pageparm.total = res.count
      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // deptList(parameter)
      //   .then(res => {
      //     this.loading = false
      //     if (res.success == false) {
      //       this.$message({
      //         type: 'info',
      //         message: res.msg
      //       })
      //     } else {
      //       this.listData = res.data
      //       // 分页赋值
      //       this.pageparm.currentPage = res.data.page_info.page
      //       this.pageparm.pageSize = res.data.page_info.page_size
      //       this.pageparm.total = res.count
      //     }
      //   })
      //   .catch(err => {
      //     this.loading = false
      //     this.$message.error('菜单加载失败，请稍后再试！')
      //   })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑chatAPI'
        this.editForm.Id = row.deptId
        this.editForm.Name = row.deptName
        this.editForm.platform = row.deptNo
        this.editForm.type = row.deptNo
        this.editForm.k_id = row.deptNo
        this.editForm.is_network = '0'
        this.editForm.is_upload = '0'
      } else {
        this.title = '新增'
        this.editForm.Id = ''
        this.editForm.Name = ''
        this.editForm.platform = ''
        this.editForm.type = ''
        this.editForm.k_id = ''
        this.editForm.is_network = '0'
        this.editForm.is_upload = '0'
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 下线用户
    offlineUser(index, row) {
      this.$confirm('确定要让' + row.userName + '用户下线吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userExpireToken(row.userName)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '用户' + row.userName + '强制下线成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('用户下线失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/chat/web.vue